// extracted by mini-css-extract-plugin
export default {"mainBox":"style_mainBox__MBMnQ","paramBox":"style_paramBox__kTZbs","categoryBox":"style_categoryBox__YXnYq"};